import Vue from 'vue'

export default async ({ app, route }) => {
  if (process.client) {
    try {
      const {default: Vuetify} = await import('vuetify')
      Vue.use(Vuetify)
      const vuetify = new Vuetify()

      const { default: VuetifyShowIcon } = await import('@/components/admin/Form/VuetifyShowIcon')
      const { default: VuetifyEditIcon } = await import('@/components/admin/Form/VuetifyEditIcon')
      const { default: VuetifyDeleteIcon } = await import('@/components/admin/Form/VuetifyDeleteIcon')
      const { default: VuetifyCopyIcon } = await import('@/components/admin/Form/VuetifyCopyIcon')

      Vue.component('vuetify-show-icon', VuetifyShowIcon)
      Vue.component('vuetify-edit-icon', VuetifyEditIcon)
      Vue.component('vuetify-delete-icon', VuetifyDeleteIcon)
      Vue.component('vuetify-copy-icon', VuetifyCopyIcon)

      app.vuetify = vuetify
      app.$vuetify = vuetify.framework
    } catch (error) {
      console.error('Error when importing Vuetify or components:', error)
    }
  }
}
